import { keys } from 'lodash';
import { mapMutations } from 'vuex';

export default {
	data() {
		return {
			beneficiaries: [1],
			nextBeneficiaries: [2, 3, 4, 5],
		};
	},
	computed: {
		hasBeneficiaries() {
			return _.map(
				_.filter(this.getSelectedOffer?.insurance_events, insurance_event => insurance_event.included),
				filtered => filtered.name,
			).includes('Balesetbiztosítás');
		},
		comutedBeneficiaryFields() {
			return index => {
				return _.mapValues(this.fields.beneficiaryData, beneficiaryData => {
					return {
						...beneficiaryData,
						refGroup: `baseData-beneficiaryData-${index}`,
					};
				});
			};
		},
	},
	methods: {
		...mapMutations('contracting', ['deleteBenediciaryData']),
		handleAddBenediciaries() {
			if (this.beneficiaries.length < 5) {
				this.beneficiaries.push(this.nextBeneficiaries.shift());
			}
		},
		handleDelete(index) {
			this.nextBeneficiaries.push(index);
			this.nextBeneficiaries.sort();
			const key = this.beneficiaries.findIndex(beneficiary => beneficiary === index);
			this.beneficiaries.splice(key, 1);
			this.deleteBenediciaryData(index);
		},
		validateRates(beneficiaries) {
			this.$nextTick(() => {
				beneficiaries.forEach(beneficiary => {
					if (this.$refs[`baseData-beneficiaryData-${beneficiary}-rate`] !== undefined) {
						this.$refs[
							`baseData-beneficiaryData-${beneficiary}-rate`
						][0].$refs.component.$refs.provider.validate();
					}
				});
			});
		},
	},
	watch: {
		beneficiaries(newVal) {
			this.validateRates(newVal);
		},
	},
};
